import MJSONScreenshot from '@admin/components/mjson_screenshot'
import PropTypes from 'prop-types'
import React from 'react'

const getScreenshot = (entity) => ({
  engine: 'mjson',
  entity: `maha_modules/${entity.code}`,
  width: 100,
  height: 75,
  screenshoted_at: entity.screenshoted_at
})

const ModuleToken = ({ module }) => (
  <div className="campaign-token">
    <div className="campaign-token-preview">
      <div className="campaign-token-preview-inner">
        <MJSONScreenshot { ...getScreenshot(module) } />
      </div>
    </div>
    <div className="campaign-token-label">
      <div className="token-link">
        <strong>{ module.title }</strong><br />
        { module.category.title }
      </div>
    </div>
  </div>
)

ModuleToken.propTypes = {
  module: PropTypes.object
}

export default ModuleToken